import { render, staticRenderFns } from "./List.vue?vue&type=template&id=340965ff&scoped=true"
import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=340965ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340965ff",
  null
  
)

export default component.exports